module.exports = "/_next/static/images/offline_product_howto-0ed9d878e8d3b53e3edbbe168974fae8.svg";